import {
  Avatar,
  Checkbox,
  Stack,
  SxProps,
  Theme,
  Typography,
} from '@mui/material';
import { Checkmark, CheckmarkChecked, CheckmarkError } from 'Images';
import { TypographyVariants } from 'ThemeV2.0';
import { stopPropagationAccessibilityBehavior } from 'Utils/accessibilityOnKeyDown';

interface ICheckboxInput {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  textVariant?: TypographyVariants;
  textSx?: SxProps;
  containerStyle?: SxProps<Theme>;
  isError?: boolean;
  errorMsg?: string;
}

export const CheckboxInput = ({
  checked,
  label,
  onChange,
  textVariant,
  textSx,
  containerStyle,
  isError,
  errorMsg,
}: ICheckboxInput) => {
  return (
    <Stack
      sx={{
        alignItems: 'center',
        flexDirection: 'row',
        gap: '8px',
        ...containerStyle,
      }}
      onKeyDown={stopPropagationAccessibilityBehavior}
    >
      <Stack direction='row'>
        <Checkbox
          tabIndex={0}
          checked={checked}
          onChange={onChange}
          inputProps={{
            'aria-label': `${label}`,
          }}
          role=''
          icon={
            <Avatar
              alt=''
              src={isError ? CheckmarkError : Checkmark}
              sx={{ width: '24px', height: '24px' }}
            />
          }
          checkedIcon={
            <Avatar
              alt={''}
              src={CheckmarkChecked}
              sx={{ width: '24px', height: '24px' }}
            />
          }
        />
        <Stack
          sx={
            isError
              ? { position: 'relative', top: '10px' }
              : { justifyContent: 'center' }
          }
        >
          <Typography sx={{ ...textSx }} variant={textVariant || 'body6'}>
            {label}
          </Typography>
          {isError && errorMsg && (
            <Typography variant='body6' sx={{ color: '#E12D2D' }}>
              {errorMsg}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};
